export interface AssignedUser {
  upn: string;
  displayName: string;
  email: string;
  assignedBy?: string;
  assignedByEmail?: string;
  isClosed: boolean;
}

export function DefaultAssignedUser(): AssignedUser {
  return {
    upn: "",
    displayName: "",
    email: "",
    assignedBy: "",
    assignedByEmail: "",
    isClosed: false,
  };
}
